import Vue from 'vue'
import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
// import VCharts from 'v-charts'
import '@/styles/index.scss'

import App from './App'
import router from './router'
import store from './store'

import '@/icons'
import '@/permission'
// import '@/utils/errorHandler'

Vue.use(ElementUI, { locale })
// Vue.use(VCharts)

Vue.config.productionTip = false

import { isInTelegramWebApp } from '@/utils/telegram';

// 如果是在 TG mini app 内开启的，就先验证
if (isInTelegramWebApp()) {
  verifyTelegramUser().then(() => {
    new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: { App }
    });
  });
} else {
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  });
}

// 验证 TG mini app Login
async function verifyTelegramUser() {
  const tg = window.Telegram.WebApp;
  tg.expand();
  const initData = tg.initData;
  const params = new URLSearchParams(initData);
  const EF_TGinitData = {};
  for (const [key, value] of params.entries()) {
    if (key === 'user') {
      try {
        EF_TGinitData[key] = decodeURIComponent(value);
      } catch (e) {
        EF_TGinitData[key] = value; // fallback
      }
    } else {
      EF_TGinitData[key] = decodeURIComponent(value);
    }
  }
  store.dispatch("TGminiAppLogin", EF_TGinitData).then(() => {
    store.dispatch("GetInfo", {}).catch(() => {
      store.dispatch("FedLogOut").then(() => {
      });
    });
  });
}




// WEBPACK FOOTER //
// ./src/main.js